export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

// user
export const GET_PROFILE = "GET_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SET_ENTITLEMENTS = "SET_ENTITLEMENTS";
export const SET_ENTITLEMENT_LIST_COUNT = "SET_ENTITLEMENT_LIST_COUNT";
export const INCREMENT_ENTITLEMENT_LIST_COUNT =
  "INCREMENT_ENTITLEMENT_LIST_COUNT";

// notification
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";

//Token

export const SET_TOKEN = "SET_TOKEN";

// Live notification feed
export const NOTIFICATION_RECEIVED = "NOTIFICATION_RECEIVED";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const CLEAR_FEED_NOTIFICATIONS = "CLEAR_FEED_NOTIFICATIONS";
export const MARK_ALL_FEED_READ = "MARK_ALL_FEED_READ";
export const MARK_FEED_NOTIFICATION_READ = "MARK_FEED_NOTIFICATION_READ";
export const REMOVE_FEED_NOTIFICATION = "REMOVE_FEED_NOTIFICATION";
